import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    ignoreBookmark: Boolean
  };

  async create(event) {
    event.preventDefault();

    const url = new URL(this.urlValue, window.location.origin);
    if (this.ignoreBookmarkValue) {
      url.searchParams.set("ignore_bookmark", "1");
    }

    try {
      const response = await fetch(url, {
        headers: {
          "Accept": "application/json"
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const data = await response.json();
      const container = document.querySelector("#blurb-draft");

      if (!container) {
        console.error("Missing #blurb-draft element in DOM");
        return;
      }

      // Replace the content safely
      container.innerHTML = data.html;

      // Stimulus automatically picks up new elements,
      // but in case of timing quirks, force a refresh event
      document.dispatchEvent(new Event("turbo:load"));
    } catch(error) {
      console.error("Error loading blurb form:", error);
    }
  }
}
